import { createTranslator } from "../../utils/translate";
import { isExpiredCourse } from "./_trainingUtils";
import de from "./de.json";
import en from "./en.json";

const translations = { de, en };

export const AvailabilityBadge = ({ course, language = "de" }) => {
  const t = createTranslator(language, translations);
  if (isExpiredCourse(course)) {
    return <span className="badge bg-yellow">{t("statusExpired")}</span>;
  }
  if (course.get("isFullyBooked")) {
    return <span className="badge bg-red">{t("statusFullyBooked")}</span>;
  }
  return <span className="badge bg-green">{t("statusAvailable")}</span>;
};
